import { PipelineService } from "@/openapi/pipeline";
import type {
  LLMFetcherArgs,
  LLMRegistryEntry,
} from "core-fe-lib/components-shadcn/primitives/LLMSelect.vue";

/**
 * Strategy for LLMSelect that pulls from this hub's pipeline registry.
 * Shared by every form that needs an LLM picker (scholar agents,
 * tenant-config LLM keys, AI-employee model picker).
 */
export const pipelineLLMFetcher = (
  args: LLMFetcherArgs
): Promise<LLMRegistryEntry[]> =>
  PipelineService.listLlmModels(
    args.provider || undefined,
    args.capability as Parameters<typeof PipelineService.listLlmModels>[1],
    true,
    args.taskType || undefined
  ) as unknown as Promise<LLMRegistryEntry[]>;
